export default {
    defaultDateTimeFormat: 'YYYY-MM-DD HH:mm',
    databaseDateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    submissionCanEditByDays: 45,
    domainUrl: 'https://datatool.workitaround.com',
    roles: {
        'RECYCLER': 2,
        'AUDITOR': 3,
        'REPRESENTATIVE': 4,
        'SECTOR_ASSOCIATION': 5,
    }
};
